import React, { useEffect, useState } from 'react'

import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import { Button, BUTTON_THEME, IconButton, Input } from '@st-operations/uikit/src/v2/index.js'

import './styles.scss'

const ModalCloneAudience = ({ selectedAudiences, isModalCloneOpen, clone, closeModal }) => {
  const actionLabel = selectedAudiences.length > 1 ? 'Clone Audiences' : 'Clone Audience'
  const [audiences, setAudiences] = useState({})

  useEffect(() => {
    setAudiences(
      selectedAudiences.reduce(
        (acc, audience) => ({
          ...acc,
          [audience._id]: audience,
        }),
        {}
      )
    )
  }, [selectedAudiences])

  useEffect(() => {
    if (isModalCloneOpen && selectedAudiences.length === 0) {
      closeModal()
      toast.error('No audience selected.')
    }
  }, [isModalCloneOpen && selectedAudiences])

  const handleChange = (id) => (value, name) => {
    setAudiences((prevState) => ({
      ...prevState,
      [id]: {
        ...prevState[id],
        [name]: value,
      },
    }))
  }

  return (
    <Dialog open={isModalCloneOpen} className="modal-clone-audience">
      <header className="modal-clone-audience__header">
        <h2>{actionLabel}</h2>
        <IconButton
          onClick={closeModal}
          aria-label="Close modal"
          iconProps={{
            icon: 'delete',
            type: 'fill',
            width: 16,
            height: 16,
            color: '#3d3d3d',
          }}
        />
      </header>
      <section className="modal-clone-audience__audiences-list">
        <For each="audience" of={Object.values(audiences)}>
          <div key={audience._id} className="modal-clone-audience__audiences-item">
            <h4 className="modal-clone-audience__name">{audience.name.split('>').at(-1)}</h4>
            <Input
              name="name"
              label="Audience Name"
              value={audience.name}
              onChange={handleChange(audience._id)}
            />
          </div>
        </For>
      </section>
      <footer className="modal-clone-audience__footer">
        <div className="modal-clone-audience__actions">
          <Button onClick={closeModal} theme={BUTTON_THEME.SECONDARY}>
            Cancel
          </Button>
          <Button
            onClick={() => {
              clone(audiences)
              closeModal()
            }}
          >
            {actionLabel}
          </Button>
        </div>
      </footer>
    </Dialog>
  )
}

export default ModalCloneAudience
